/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UpdateHistoryRecordDto = {
    duration?: number;
    endDate?: number;
    id: string;
    isTruncatedStatement?: boolean;
    queryStatement?: string;
    startDate: number;
    status?: UpdateHistoryRecordDto.status;
    type?: string;
    user?: string;
};

export namespace UpdateHistoryRecordDto {

    export enum status {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        UNKNOWN = 'UNKNOWN',
    }


}
